<div class="edit-form">
  <mat-spinner *ngIf="uploading"></mat-spinner>
  <h3>
    {{
      'ALBUMS - ' 
      + (data.mode === 'edit' ? ('Edit Record n.' + (data.index+1)) : ('Add New Record at position ' + (data.index!+1)) )
    }}
  </h3>
  <div class="add-album" *ngIf="data.mode==='add'" (click)="fileInput.click()">
    <div class="spinner-wrapper" *ngIf="loadingAlbum">
      <mat-spinner color="primary" diameter="40"></mat-spinner>
    </div>
    <img 
      *ngIf="imageSrc!==''; else addAlbumImg"
      [src]="imageSrc" 
      alt="Preview" 
      (load)="onImageLoad()"
    />
    <ng-template #addAlbumImg>ADD ALBUM IMG</ng-template>
    <input #fileInput type="file" accept=".jpg" (change)="onFileSelected($event)" style="display: none;" />
  </div>
  <div class="preview" *ngIf="data.mode==='edit'">
    <div class="spinner-wrapper" *ngIf="loadingAlbum">
      <mat-spinner color="primary" diameter="40"></mat-spinner>
    </div>
    <img
      [src]="editForm.value.imgUrl"
      alt="Preview"
      (load)="onImageLoad()"
    />
  </div>
  <form
      [formGroup]="editForm"
      (ngSubmit)="saveRecord()"
  >
    <input
      formControlName="title"
      placeholder="Title"
      type="text"
      required
      (keydown)="preventSubmit($event)"
    />
    <input
      formControlName="author"
      placeholder="Author"
      type="text"
      required
      (keydown)="preventSubmit($event)"
    />
    <input
      formControlName="label"
      placeholder="Label"
      type="text"
      required
      (keydown)="preventSubmit($event)"
    />
    <input
      formControlName="year"
      placeholder="Year"
      type="text"
      required
      (keydown)="preventSubmit($event)"
    />
    <textarea
      formControlName="description"
      placeholder="Description"
    ></textarea>
    <button type="submit">Save</button>
    <button type="button" (click)="cancel()">Cancel</button>
  </form>
</div>